/*
 * Author: Roger
 * File Created: Friday, 24-08-23 07:45 pm
 * Last Modified: Monday, 25-05-12 04:01 pm, by Ben Zhao
 */

import { useTranslation } from 'next-i18next';
import { Box, Divider, Link, Stack, Typography } from '@mui/material';
import Image from '@/components/Image';
import { staticImgPrefix, staticPrefix } from '@/utils/prefix';
import { BottomTextBox } from './style';
interface FooterBottomProps {
  isXs: boolean;
}
const FooterBottom: React.FC<FooterBottomProps> = ({
  isXs
}) => {
  const {
    t
  } = useTranslation('common');
  return <Box mb={[5, 2.5]} mt={[5, 7.5]} data-sentry-element="Box" data-sentry-component="FooterBottom" data-sentry-source-file="FooterBottom.tsx">
      <Divider sx={{
      mb: [2, 3]
    }} data-sentry-element="Divider" data-sentry-source-file="FooterBottom.tsx" />
      <BottomTextBox data-sentry-element="BottomTextBox" data-sentry-source-file="FooterBottom.tsx">
        <Stack data-sentry-element="Stack" data-sentry-source-file="FooterBottom.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="FooterBottom.tsx">
            {t('landing-footer.text.copyright', {
            year: new Date().getFullYear()
          })}
          </Typography>
          <Typography variant="body2" data-sentry-element="Typography" data-sentry-source-file="FooterBottom.tsx">
            <Link color="inherit" href="https://dcscc.com/legal/privacy-policy" target="_blank" data-sentry-element="Link" data-sentry-source-file="FooterBottom.tsx">
              {t('landing-footer.text.policy')}
            </Link>{' '}
            |{' '}
            <Link color="inherit" href={staticPrefix('/agreements/DeCard_Terms_Conditions.pdf')} target="_blank" data-sentry-element="Link" data-sentry-source-file="FooterBottom.tsx">
              {t('landing-footer.text.terms')}
            </Link>
          </Typography>
          {!isXs && <Image alt="dcs" height={36} src={staticImgPrefix('/home/dcs_logo.webp')} width={58} />}
        </Stack>
        {isXs && <Image alt="dcs" height={36} src={staticImgPrefix('/home/dcs_logo.webp')} width={58} />}
      </BottomTextBox>
    </Box>;
};
export default FooterBottom;